import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, initAnalytics } from '../lib/analytics';

/**
 * Single global hook that:
 *  1. Initialises the analytics provider once on mount.
 *  2. Tracks a pageview every time the route path changes.
 *
 * Mount once at the top of <App/>.
 */
export const usePageviewTracking = () => {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === lastPathRef.current) return;
    lastPathRef.current = path;
    // Defer to next tick so SEO <title> updates land first in PostHog properties.
    const id = window.setTimeout(() => trackPageview(path), 50);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);
};

export default usePageviewTracking;
